<template>
	<div class="">
		<!-- 用于选择公司、以及区域 -->
		<!--公司及区域选择  区域不包含动环组-->
		<div v-if="areaFlag==true">
			<el-select class="" @change="clickCom()" value-key="uid" v-if="administrators!=1 && administrators!=2" v-model="selectComId" placeholder="请选择公司">
				<el-option label="所有公司" key="-1" value=""></el-option>
				<el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
			</el-select>
			<el-select class="" v-model="selectAreaId" @change="toParent()" placeholder="请选择区域">
				<el-option v-for="(area,index) in areaList" v-if="area.group_name!='动环'" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
			</el-select>
			<el-button @click="checkMore()"> 查 看 </el-button>
		</div>
		<!--公司及区域选择  区域包含动环组-->
		<div v-if="areaFlag==3">
			<el-select class="" @change="clickCom()" value-key="uid" v-if="administrators!=1 && administrators!=2" v-model="selectComId" placeholder="请选择公司">
				<el-option label="所有公司" key="-1" value=""></el-option>
				<el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
			</el-select>
			<el-select class="" v-model="selectAreaId" @change="toParent()" placeholder="请选择区域">
				<el-option v-for="(area,index) in areaList" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
			</el-select>
			<el-button @click="checkMore()"> 查 看 </el-button>
		</div>
		<!-- 只选择公司 动环用-->
		<div v-if="!areaFlag">
			<el-select class="ml20" @change="toParent()" value-key="uid" v-if="this.administrators!=1 && this.administrators!=2" v-model="selectComId" placeholder="请选择公司">
			
				<el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
			</el-select>
			
			<el-button @click="checkMore()" v-if="this.administrators!=1 && this.administrators!=2"> 查 看 </el-button>
		</div>
	</div>
</template>
<script>
export default {
  name: 'app',
  props:['areaFlag'],
  data(){
    return {
		administrators:this.getCookie('administrators'),
		areaList:[],
		comList:[],
		selectComId:null,
		selectCom:{},
		selectAreaId:null,
		// true表示有区域选择,false则无
		myareaFlag: this.areaFlag || true
    }
  },
  mounted(){
    this.$nextTick(function(){
		if(this.administrators!=1 && this.administrators!=2){
			this.getCompanyList();
		}
		if(this.administrators==1 || this.administrators==2){
			this.clickCom();
		}
    	
  	})
  },

  methods: {
	  		checkMore(){
				  this.$parent.toChooseCompanyMethod();
			  },
	  		//			获取公司列表
			getCompanyList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		type:2,
		  			company_id:this.getCookie('company_id'),
		  			page:"1",
	  				pagesize:"9999",
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsList/AdministratorsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		if(res.data.data.name){
		        			this.comList = res.data.data.name || [];
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			//			点击选择公司
			clickCom(){
//				点击公司后赋值当前选中区域为空
				this.selectAreaId = null;
				//超级管理员和普通管理员分别管理，uid参数不一样，超级管理员获取所选公司管理员的ID，普通管理员直接传入本身id
				if(this.administrators!=1 && this.administrators!=2){
					//点击赋值当前选中公司
					for(var i=0;i<this.comList.length;i++){
						if(this.comList[i].company_id == this.selectComId){
							this.selectCom = this.comList[i];
						}
					}	
				}else{
					this.selectCom.uid = this.getCookie('uid');
				}

				let valiCodeParams={
					uid:this.selectCom.uid || -1,
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PacketList/PacketList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 && res.data.data!=null){
		        		this.areaList = res.data.data;
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},

			// 将公司区域信息传值给父组件
			toParent(){
				let comData = {
					selectComId: this.selectComId,
					selectAreaId: this.selectAreaId,
				}
				this.$emit('event1', comData);
			}
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/chooseCompany.vue